export default __webpack_public_path__ + "static/media/Group 8221.8e79c163.png";